import { onboarding } from '@services';

export interface IPatchAssetById {
  groupId: string;
  studioId: string;
  fileId: string;
  mpn?: string;
  mfr?: string | null;
  productName?: string;
  mpnError?: null;
  mfrError?: null;
  productNameError?: null;
}

const patchAssetById = async ({
  groupId,
  studioId,
  fileId,
  mfr,
  mpn,
  productName,
  mfrError,
  mpnError,
  productNameError,
}: IPatchAssetById): Promise<void> => {
  await onboarding.patch(
    `/api/v1/assets/id/import?studioId=${studioId}&groupId=${groupId}&fileId=${fileId}`,
    {
      mfr,
      mpn,
      productName,
      mpnError,
      mfrError,
      productNameError,
    },
  );
};

export { patchAssetById };
